import React from 'react'

const CustomerContact = (props: any) => {
  const { contactData, label, handleUpdateContact, branch, city } = props
  return (
    <div className="relative flex flex-col min-w-0 break-words bg-white w-full">
      <div className="block w-full overflow-x-auto">
        <table className="items-center bg-transparent w-full border-collapse ">
          <thead>
            <tr>
              <th className="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                {label}
              </th>
              <th className="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                Contact
              </th>
              {/* <th className="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                Alt Contact
              </th> */}
            </tr>
          </thead>
          <tbody>
            {contactData?.map((item: any, index: number) => (
              <tr className='even:bg-gray-50 odd:bg-white'>
                <th className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap text-left text-blueGray-700 ">
                  {item?.destination?.name}
                </th>
                <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap ">
                  <input type="text" defaultValue={item?.contact} className='w-full p-1 outline-none bg-transparent ' onBlur={(e:any)=>handleUpdateContact(e.target.value, item?.destination.id, branch, city)} />
                </td>
                {/* <td className="border-t-0 px-6 align-center border-l-0 border-r-0 text-xs whitespace-nowrap">
                  <input type="text" className='w-full p-1 outline-none bg-transparent ' />
                </td> */}
              </tr>
            ))}
          </tbody>

        </table>
      </div>
    </div>
  )
}

export default CustomerContact